<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" md="4">
                <AutocompleteSchoolYear :defaultYear="defaultYear.id" @change="change" />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="levelOptions"
                  v-model="academicLevel"
                  label="Cấp"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <AutocompleteSubjectGroup
                  v-model="subjectGroup"
                  item-text="title"
                  item-value="id"
                  label="Tổ"
                  dense
                  outlined
                  auto-select-first
                  :hideDetails="true"
                  :disabled="academicLevel === ''"
                  :options="{hideInSecondary: academicLevel === 'secondary'}"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <div class="d-flex justify-end">
              <v-btn
                class="search-button"
                :class="{ 'px-2': windowWidth < 1100 }"
                @click="onFilterChanged"
                outlined
                :disabled="!this.academicLevel || !this.subjectGroup"
              >
                Tìm kiếm
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import AutocompleteSubjectGroup from '../input/AutocompleteSubjectGroup.vue'
import AutocompleteSchoolYear from '@/components/basic/input/AutocompleteSchoolYear.vue'
import { Teaching } from '@/plugins/api'
import { uniq, get } from 'lodash'

const LEVEL_OPTIONS = [
  { name: 'Cấp 2', value: 'secondary' },
  { name: 'Cấp 3', value: 'high' }
]
export default {
  components: {
    AutocompleteSubjectGroup,
    AutocompleteSchoolYear
  },
  data: () => ({
    show: false,
    status: 'active',
    title: '',
    code: '',
    subjectGroup: '',
    academicLevel: '',
    windowWidth: window.innerWidth,
    levelOptions: LEVEL_OPTIONS,
    defaultYear: {},
    schoolYear: null
  }),
  props: {
    defaultFilters: Object
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    ...mapState('grade', ['query']),
    ...mapState('auth', ['role', 'profile']),
    ...mapState('app', ['currentSchoolYear'])
  },
  async created() {
    if (this.role.type === 'teacher') {
      const teachings = await Teaching.fetch({ teacher: this.profile.id, _limit: -1 })
      const allowedLevels = uniq(teachings.map(x => get(x, 'academicLevel.type')).filter(Boolean))
      this.levelOptions = LEVEL_OPTIONS.filter(x => allowedLevels.includes(x.value))
    }
  },
  methods: {
    ...mapMutations({ setSchoolYearId: 'teacherDoc/setSchoolYearId' }),
    onFilterChanged() {
      const query = {
        subjectGroup: this.subjectGroup,
        academicLevel: this.academicLevel,
        schoolYear: this.schoolYear
      }
      this.setSchoolYearId(this.schoolYear)
      this.$emit('onFilterChanged', query)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    change(data) {
      this.schoolYear = data
    }
  },
  mounted() {
    if (get(this.currentSchoolYear, 'id')) {
      this.defaultYear = this.currentSchoolYear
      this.schoolYear = get(this.currentSchoolYear, 'id', null)
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>
<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
}
</style>
